var map = {
	"./assert.d.ts": 355,
	"./async_hooks.d.ts": 356,
	"./base.d.ts": 357,
	"./buffer.d.ts": 358,
	"./child_process.d.ts": 359,
	"./cluster.d.ts": 360,
	"./console.d.ts": 361,
	"./constants.d.ts": 362,
	"./crypto.d.ts": 363,
	"./dgram.d.ts": 364,
	"./dns.d.ts": 365,
	"./domain.d.ts": 366,
	"./events.d.ts": 367,
	"./fs.d.ts": 368,
	"./fs/promises.d.ts": 369,
	"./globals.d.ts": 370,
	"./globals.global.d.ts": 371,
	"./http.d.ts": 372,
	"./http2.d.ts": 373,
	"./https.d.ts": 374,
	"./index.d.ts": 375,
	"./inspector.d.ts": 376,
	"./module.d.ts": 377,
	"./net.d.ts": 378,
	"./os.d.ts": 379,
	"./path.d.ts": 380,
	"./perf_hooks.d.ts": 381,
	"./process.d.ts": 382,
	"./punycode.d.ts": 383,
	"./querystring.d.ts": 384,
	"./readline.d.ts": 385,
	"./repl.d.ts": 386,
	"./stream.d.ts": 387,
	"./string_decoder.d.ts": 388,
	"./timers.d.ts": 389,
	"./tls.d.ts": 390,
	"./trace_events.d.ts": 391,
	"./ts3.4/assert.d.ts": 392,
	"./ts3.4/base.d.ts": 393,
	"./ts3.4/globals.global.d.ts": 394,
	"./ts3.4/index.d.ts": 395,
	"./ts3.6/base.d.ts": 396,
	"./ts3.6/index.d.ts": 397,
	"./tty.d.ts": 398,
	"./url.d.ts": 399,
	"./util.d.ts": 400,
	"./v8.d.ts": 401,
	"./vm.d.ts": 402,
	"./wasi.d.ts": 403,
	"./worker_threads.d.ts": 404,
	"./zlib.d.ts": 405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354;